import { render, staticRenderFns } from "./Singapore.vue?vue&type=template&id=cd7f292a&"
import script from "./Singapore.vue?vue&type=script&lang=js&"
export * from "./Singapore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd7f292a')) {
      api.createRecord('cd7f292a', component.options)
    } else {
      api.reload('cd7f292a', component.options)
    }
    module.hot.accept("./Singapore.vue?vue&type=template&id=cd7f292a&", function () {
      api.rerender('cd7f292a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Singapore.vue"
export default component.exports